import { Theme } from '@material-ui/core';

export const styles = (theme: Theme) => ({
  fabContainer: {
    display: 'flex',
    flexDirection: 'row-reverse' as 'row-reverse',
    marginRight: theme.spacing(2),
  },
});
